import React from 'react';
import { useDispatch } from 'react-redux';
import { setFiltroUsuarios } from "../../actions/usuariosActions";

export default function FiltroUsuarios({ filtro, fetchUsuarios }) {
  const { nombreUsuario } = filtro;
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedParams = { ...filtro, [name]: value };
    dispatch(setFiltroUsuarios(updatedParams));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(setFiltroUsuarios({ ...filtro, numeroPagina: 1 })).then(() => fetchUsuarios());
  };

  const handleReset = () => {
    const params = { nombreUsuario: "", numeroPagina: 1 };
    dispatch(setFiltroUsuarios(params)).then(() => fetchUsuarios());
  }

  return (
    <form
      className="card card-body filter-card form-material"
      onSubmit={handleSubmit}
      onReset={handleReset}
    >
      <div className="row align-items-end">
        <div className="col-12 col-sm-3 col-md-2">
          <label className="label-oscura">Nombre Usuario</label>
          <input
            type="text"
            name="nombreUsuario"
            className="form-control"
            value={nombreUsuario || ""}
            onChange={handleChange}
            maxLength="30"
          />
        </div>

        <div className="col-12 col-sm-auto">
          <button type="submit" className="btn btn-sm btn-grey mt-2 mt-sm-0">Buscar</button>
          <button type="reset" className="btn btn-sm btn-grey ms-0 ms-sm-2 mt-2 mt-sm-0">Limpiar</button>
        </div>
      </div>
    </form>
  )
}